import { Routes, Route } from 'react-router-dom';
import { TournamentProvider } from './TournamentContext';
import { AppPrefixProvider } from './AppPrefixContext';
import { useAnalyticsTracker } from '../hooks/useAnalyticsTracker';
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { useAutoDeviceRegistration } from '../hooks/useAutoDeviceRegistration';
import MobileNavBar from './MobileNavBar';
import MobileTopBar from './MobileTopBar';
import MobileHome from './pages/MobileHome';
import MobileSchedule from './pages/MobileSchedule';
import MobileLeaderboard from './pages/MobileLeaderboard';
import MobileMore from './pages/MobileMore';
import MobileAbout from './pages/MobileAbout';
import MobileRegistration from './pages/MobileRegistration';
import MobileHistory from './pages/MobileHistory';
import MobileSponsors from './pages/MobileSponsors';
import MobilePrizeBreakdown from './pages/MobilePrizeBreakdown';
import MobilePress from './pages/MobilePress';
import MobileEventCalendar from './pages/MobileEventCalendar';
import MobilePrivacyPolicy from './pages/MobilePrivacyPolicy';
import MobileTerms from './pages/MobileTerms';
import MobileDashboard from './pages/MobileDashboard';
import MobileAdminPlayers from './pages/admin/MobileAdminPlayers';
import MobileAdminPartners from './pages/admin/MobileAdminPartners';
import MobileAdminEvents from './pages/admin/MobileAdminEvents';
import MobileAdminFinance from './pages/admin/MobileAdminFinance';
import MobileAdminAnalytics from './pages/admin/MobileAdminAnalytics';
import MobileAdminSettings from './pages/admin/MobileAdminSettings';
import MobileAdminTournaments from './pages/admin/MobileAdminTournaments';
import MobileAdminPress from './pages/admin/MobileAdminPress';
import MobileAdminContent from './pages/admin/MobileAdminContent';
import MobileAdminCalendar from './pages/admin/MobileAdminCalendar';
import MobileAdminCourses from './pages/admin/MobileAdminCourses';
import MobileAdminScores from './pages/admin/MobileAdminScores';
import MobileAdminMessaging from './pages/admin/MobileAdminMessaging';
import MobileInvite from './pages/MobileInvite';
import MobileSupport from './pages/MobileSupport';
import MobileSettingsAccount from './pages/admin/settings/MobileSettingsAccount';
import { SettingsProvider } from '../contexts/SettingsContext';
import { ScorerAuthGate } from './ScorerApp';
import AdminAuthGate from '../components/AdminAuthGate';
import ScorerHome from './pages/scorer/ScorerHome';
import ScorerGroupsPage from './pages/scorer/ScorerGroupsPage';
import ScorerGroupScoreEntry from './pages/scorer/ScorerGroupScoreEntry';
import MobilePlayerDetails from './pages/MobilePlayerDetails';
import MobilePromo from './pages/MobilePromo';

export default function MobileApp() {
  useGoogleAnalytics();
  useAnalyticsTracker();
  usePushNotifications();
  useAutoDeviceRegistration();

  return (
    <AppPrefixProvider prefix="/m">
    <TournamentProvider>
    <div className="min-h-screen bg-gray-50 font-body">
      <MobileTopBar />

      <main className="pt-14 pb-20">
        <Routes>
          <Route index element={<MobileHome />} />
          <Route path="schedule" element={<MobileSchedule />} />
          <Route path="calendar" element={<MobileEventCalendar />} />
          <Route path="leaderboard" element={<MobileLeaderboard />} />
          <Route path="player/:playerId" element={<MobilePlayerDetails />} />
          <Route path="more" element={<MobileMore />} />
          <Route path="about" element={<MobileAbout />} />
          <Route path="registration" element={<MobileRegistration />} />
          <Route path="history" element={<MobileHistory />} />
          <Route path="sponsors" element={<MobileSponsors />} />
          <Route path="prize-breakdown" element={<MobilePrizeBreakdown />} />
          <Route path="press" element={<MobilePress />} />
          <Route path="privacy-policy" element={<MobilePrivacyPolicy />} />
          <Route path="terms" element={<MobileTerms />} />
          <Route path="support" element={<MobileSupport />} />
          <Route path="admin" element={<AdminAuthGate requiredTab="dashboard" redirectTo="/m"><MobileDashboard /></AdminAuthGate>} />
          <Route path="admin/players" element={<AdminAuthGate requiredTab="players" redirectTo="/m/admin"><MobileAdminPlayers /></AdminAuthGate>} />
          <Route path="admin/partners" element={<AdminAuthGate requiredTab="partners" redirectTo="/m/admin"><MobileAdminPartners /></AdminAuthGate>} />
          <Route path="admin/events" element={<AdminAuthGate requiredTab="calendar" redirectTo="/m/admin"><MobileAdminEvents /></AdminAuthGate>} />
          <Route path="admin/finance" element={<AdminAuthGate requiredTab="finance" redirectTo="/m/admin"><MobileAdminFinance /></AdminAuthGate>} />
          <Route path="admin/analytics" element={<AdminAuthGate requiredTab="analytics" redirectTo="/m/admin"><MobileAdminAnalytics /></AdminAuthGate>} />
          <Route path="admin/settings" element={<AdminAuthGate requiredTab="settings" redirectTo="/m/admin"><MobileAdminSettings /></AdminAuthGate>} />
          <Route path="admin/tournaments" element={<AdminAuthGate requiredTab="tournaments" redirectTo="/m/admin"><MobileAdminTournaments /></AdminAuthGate>} />
          <Route path="admin/press" element={<AdminAuthGate requiredTab="press" redirectTo="/m/admin"><MobileAdminPress /></AdminAuthGate>} />
          <Route path="admin/content" element={<AdminAuthGate requiredTab="contents" redirectTo="/m/admin"><MobileAdminContent /></AdminAuthGate>} />
          <Route path="admin/calendar" element={<AdminAuthGate requiredTab="calendar" redirectTo="/m/admin"><MobileAdminCalendar /></AdminAuthGate>} />
          <Route path="admin/courses" element={<AdminAuthGate requiredTab="courses" redirectTo="/m/admin"><MobileAdminCourses /></AdminAuthGate>} />
          <Route path="admin/scores" element={<AdminAuthGate requiredTab="scores" redirectTo="/m/admin"><MobileAdminScores /></AdminAuthGate>} />
          <Route path="admin/messaging" element={<AdminAuthGate requiredTab="messaging" redirectTo="/m/admin"><MobileAdminMessaging /></AdminAuthGate>} />
          <Route path="admin/settings/account" element={<AdminAuthGate requiredTab="account" redirectTo="/m/more"><SettingsProvider><div className="px-4 py-4"><MobileSettingsAccount /></div></SettingsProvider></AdminAuthGate>} />
          <Route path="scorer" element={<ScorerAuthGate><ScorerHome /></ScorerAuthGate>} />
          <Route path="scorer/groups" element={<ScorerAuthGate><ScorerGroupsPage /></ScorerAuthGate>} />
          <Route path="scorer/group/:groupNumber" element={<ScorerAuthGate><ScorerGroupScoreEntry /></ScorerAuthGate>} />
          <Route path="invite" element={<MobileInvite />} />
          <Route path="promo" element={<MobilePromo />} />
        </Routes>
      </main>

      <MobileNavBar />
    </div>
    </TournamentProvider>
    </AppPrefixProvider>
  );
}
